import React, {ReactNode} from "react";
import {css, Theme} from "@emotion/react";
import styled from "@emotion/styled";

import {flex, ml} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";
import {useUserDevice} from "@pg-mono/user-device";

export interface IPictogramProps {
    label: string;
    value: string | number | ReactNode;
    icon: React.ElementType;
    mobileLabel?: string;
    className?: string;
}

export const Pictogram = (props: IPictogramProps) => {
    const {isMobile} = useUserDevice();

    const Icon = props.icon;

    return (
        <div css={flex("center")} className={props.className}>
            <div>
                <Icon css={icon} />
            </div>

            <div css={content}>
                <Label variant="info_txt_1">{isMobile ? props.mobileLabel || props.label : props.label}</Label>
                <Text variant="body_copy_1" strong>
                    {props.value}
                </Text>
            </div>
        </div>
    );
};

const content = css`
    display: flex;
    flex-direction: column;
    ${ml(3)};
`;

const icon = (theme: Theme) => css`
    transform: scale(2.4);

    @media (min-width: ${theme.breakpoints.md}) {
        transform: scale(4);
    }
`;

const Label = styled(Text)`
    color: ${(props) => props.theme.colors.gray["700"]};
`;
import React, {ReactNode} from "react";
import {css, Theme} from "@emotion/react";
import styled from "@emotion/styled";

import {flex, ml} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";
import {useUserDevice} from "@pg-mono/user-device";

export interface IPictogramProps {
    label: string;
    value: string | number | ReactNode;
    icon: React.ElementType;
    mobileLabel?: string;
    className?: string;
}

export const Pictogram = (props: IPictogramProps) => {
    const {isMobile} = useUserDevice();

    const Icon = props.icon;

    return (
        <div css={flex("center")} className={props.className}>
            <div>
                <Icon css={icon} />
            </div>

            <div css={content}>
                <Label variant="info_txt_1">{isMobile ? props.mobileLabel || props.label : props.label}</Label>
                <Text variant="body_copy_1" strong>
                    {props.value}
                </Text>
            </div>
        </div>
    );
};

const content = css`
    display: flex;
    flex-direction: column;
    ${ml(3)};
`;

const icon = (theme: Theme) => css`
    transform: scale(2.4);

    @media (min-width: ${theme.breakpoints.md}) {
        transform: scale(4);
    }
`;

const Label = styled(Text)`
    color: ${(props) => props.theme.colors.gray["700"]};
`;
